import {EnkelGruppeModell, FargeHex} from "../tjenester/ressurser/generertNg2HttpKlient";
import {color, cubehelix, rgb, RGBColor} from "d3";
import {erTomEllerNil} from "felles-ng2/støttefunksjoner/strenger";
import {nil} from "felles-ng2/typer/nullish";
import {erNil} from "felles-ng2/støttefunksjoner/nilsjekk";

export type GruppeMedFarge = Pick<EnkelGruppeModell, 'farge'>;

/** Standard gruppefarge som gis til nye grupper med mindre bruker velger annen farge.
 * Må holdes i synk med no.systemfabrikken.lederplan.domene.gruppe.Gruppe.GruppeBygger#standardGruppefarge */
export const standardGruppefarge = color('#71a004') as RGBColor

const gruppefargeCache = new Map<FargeHex, Gruppefarge>();

export function gruppefargeNilsikker(gruppe: GruppeMedFarge | nil): Gruppefarge {
    if (erNil(gruppe)) return new Gruppefarge(standardGruppefarge.formatHex());
    return gruppefarge(gruppe);
}

export function gruppefarge(gruppe: GruppeMedFarge): Gruppefarge {
    if (!gruppefargeCache.has(gruppe.farge))
        gruppefargeCache.set(gruppe.farge, new Gruppefarge(gruppe.farge));
    return gruppefargeCache.get(gruppe.farge)!;
}

/** Klasse som beregner ulike varianter av {@link EnkelGruppeModell#farge} for ulike formål.
 * Merk at vi for svært lyse farger justerer rammeFarge, bakgrunnFarge og tekstBakgrunnFarge til en mørkere tone
 * for at ikke kontrast skal bli for dårlig */
export class Gruppefarge {
    readonly farge: FargeHex;
    readonly rammeFarge: FargeHex;
    readonly bakgrunnFarge: FargeHex;
    readonly tekstBakgrunnFarge: FargeHex;
    readonly tekstFarge: FargeHex;

    constructor(farge: FargeHex) {
        //midlertidig fiks for situasjonen der gruppe.farge ikke er definert - noe som kan skje dersom data lagret i localstorage
        //ikke er refresha - dvs bruker logget inn før gruppefarge ble impl, åpner så nettleser (data leses fra localstorage) etter at versjon
        //med gruppefarge har blitt prodsatt. Gruppe-objektet vil da ikke ha farge-feltet.
        if (erTomEllerNil(farge)) farge = standardGruppefarge.formatHex();
        let _farge = rgb(farge);
        const lyshet = cubehelix(_farge).l

        this.farge = _farge.formatHex();
        this.rammeFarge = _farge.formatHex();
        this.bakgrunnFarge = _farge.copy({opacity: 0.2}).formatHex8();
        this.tekstBakgrunnFarge = _farge.copy({opacity: 0.6}).formatHex8();
        this.tekstFarge = cubehelix(this.tekstBakgrunnFarge).l < 0.45 ? '#ffffff' : '#000000'; //sørger for hvit tekst på mørk bakgrunn

        if (lyshet > 0.94) {
            this.rammeFarge = _farge.darker(0.2).formatHex8();
            this.bakgrunnFarge = _farge.darker(0.2).copy({opacity: 0.2}).formatHex8();
            this.tekstBakgrunnFarge = _farge.darker(0.2).copy({opacity: 0.6}).formatHex8();
        }
    }
}
